<template>
  <div class="failure">
    <!-- <GlobalInfoBar title="低端机功能项设置" content="功能项将用于门店端小程序低端机询价时，提供展示快捷选项" /> -->
    <div class="case">
      <div class="case-title">
        <img class="case-title_icon" src="@/assets/images/icon_hsfl_.png" alt />
        <div class="case-title_max">回收分类</div>
      </div>
      <div class="class_type">
        <el-radio-group v-model="machineTypeId" v-if="classList.length != 0">
          <el-radio-button v-for="item in classList" :key="item.id" :label="item.id">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <span v-else class="tip">暂无低端机分类数据，请先添加标记</span>
      </div>
      <GlobalChunk icon="breakdown" title="故障选项">
        <div class="flex flex-jb mb-20">
          <GardenSlwct
            :tab-data="tabData"
            :activeIndex="activeIndex"
            border-radius="40px"
            @tabAction="tabAction"
          >
          </GardenSlwct>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addSelection">添加选项
          </el-button>
        </div>
        <GlobalTable ref="GlobalTable" v-loading="tableLoading" :columns="tableColumns" :data="tableData" :currentPage="page.pageNum" :pageSize="page.pageSize" :total="page.total" @handleCurrentChange="handleCurrentChange">
          <el-table-column label="选项名称" slot="optionName" align="center">
            <template slot-scope="{ row }">
              <div class="flex" style="justify-content: center;">
                <el-tag size="mini" style="margin-right: 10px;" :type="row.isNormal?'':'danger'">{{row.isNormal?'正常':'异常'}}</el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="row.optionName"
                  placement="top"
                >
                  <span class="nowrap-ellipsis" style="text-align: left;">{{ row.optionName }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="示例图" slot="exampleImg" align="center">
            <template slot-scope="{ row }">
              <img v-if="row.exampleImg" :src="row.exampleImg" style="width: 70px;height:70px" alt="" @click="seeSampleImage(row)" />
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="选项描述" slot="optionTip" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                v-if="row.optionTip"
                class="item"
                effect="dark"
                :content="row.optionTip"
                placement="top"
              >
                <span class="nowrap-ellipsis">{{ row.optionTip }}</span>
              </el-tooltip>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="设置机型" slot="model" align="center">
            <template slot-scope="{ row }">
              <p v-if="row.machineConfig == '00'">全部机型</p>
              <p v-else class="link primary" @click="modelConfigNext(row)">指定{{ row.machineNum || 0 }}个机型</p>
              <p class="link danger" @click="$refs['modelConfigDia'].open(row)">修改配置</p>
            </template>
          </el-table-column>
          <el-table-column label="外部功能项" slot="outFunction" align="center">
            <template slot-scope="{ row }">
              <template v-if="row.isBind">
                <p class="link primary" @click="seeBind(row)">查看</p>
                <p class="link" @click="cancelBind(row)">取消绑定</p>
              </template>
              <p class="link danger" v-else @click="bindItem(row)">绑定</p>
            </template>
          </el-table-column>
          <el-table-column label="排序" slot="sort" align="center" width="170">
            <template slot-scope="{row}">
              <el-input-number size="mini" v-model="row.sort" :min="0"
                @change="handleSortChange(row)"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="启用/禁用" slot="isEnable" align="center">
            <template slot-scope="{ row }">
              <el-switch inactive-color="#bebebe" @change="handleSwitch(row)" v-model="row.isEnable"></el-switch>
            </template>
          </el-table-column>
          <el-table-column width="200" label="操作" slot="operation" align="center">
            <template slot-scope="{ row }">
              <div class="table_operation">
                <el-button size="mini" type="danger" @click="delRow(row)">删除</el-button>
                <el-button size="mini" type="primary" @click="editRow(row)">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </GlobalTable>
      </GlobalChunk>
    </div>
    <!--添加或者编辑示例图弹框-->
    <el-dialog v-if="addSelectDiaShow" :title="addSelectTitle" :visible.sync="addSelectDiaShow" :close-on-click-modal="false" width="700px"
      @closed="closedAddSelectDia">
      <el-form ref="formRef" :model="formData" :rules="formRule" label-width="150px" class="detectionform">
        <el-form-item label="选择类型" prop="isNormal">
          <el-radio-group v-model.trim="formData.isNormal">
            <el-radio :label='true'>正常</el-radio>
            <el-radio :label='false'>异常</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选项编码" prop="failureCode">
          <el-input :disabled="formData.id" v-model.trim="formData.failureCode" maxlength="20" placeholder="请输入选项编码，最多20位，由小写字母或数字组成" type="text" size="small" @input="formData.failureCode = formData.failureCode.replace(/[^a-z0-9]/g, '')" />
        </el-form-item>
        <el-form-item label="选项名称" prop="optionName">
          <el-input v-model.trim="formData.optionName" maxlength="15" placeholder="请输入选项名称" type="text" size="small" />
        </el-form-item>
        <el-form-item label="设置选项描述">
          <el-input type="textarea" v-model.trim="formData.optionTip" placeholder="请输入选项描述，最多50字" maxlength="50"
            show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="选项示例图(最多1张)" prop="exampleImg">
          <ElImgUpload :isBigImg="true" :exist-image="formData.exampleImg"
            placeTxt="提示：图片仅支持上传jpg/png/gif格式，大小不超过2M" @handleChange="sampleHandleChange" @handleDelete="sampleDelete" />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addSelectDiaShow = false">取消</el-button>
        <el-button type="primary" :loading="confirmBtnLoading" @click.native="confirmAdd">确定</el-button>
      </span>
    </el-dialog>
    <!-- 启用、禁用提示 -->
    <el-dialog title="提示" :visible.sync="sureTipDiaShow" :close-on-click-modal="false" width="500px"
      @closed="sureTipDiaClosed">
      <div style="
        font-size: 16px;
        color: #666666;
        line-height: 50px;
      ">
        <div style="text-align: center;">{{ sureTipDiaText }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="sureTipDiaShow = false">取消</el-button>
        <el-button type="primary" :loading="sureTipBtnLoading" @click.native="sureTipDiaSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="绑定功能项" :visible.sync="bindOptionDiaShow" :close-on-click-modal="false" width="1000px">
      <el-form :inline="true" :model="bindOptionForm">
        <el-form-item label="渠道名称">
          <el-select
            size="small"
            v-model="bindOptionForm.channelCode"
            placeholder="请选择渠道查询"
          >
            <el-option
              v-for="item in channelList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开机情况">
          <el-select
            size="small"
            v-model="bindOptionForm.startType"
            placeholder="请选择开机情况查询"
            clearable
          >
            <el-option
              v-for="item in tabData"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="bindCurrentChange(1)"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <GlobalTable ref="GlobalTable2" v-loading="bindTableLoading" :columns="bindTableColumns" :data="bindOptionDataList" :currentPage="bindOptionForm.pageNum" :pageSize="bindOptionForm.pageSize" :total="bindOptionForm.total" @handleCurrentChange="bindCurrentChange">
        <el-table-column label="开机情况" slot="startType" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.startType=='01'?'正常开机':row.startType=='00'?'不能开机':'' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="外部等级描述" slot="description" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              v-if="row.description"
              class="item"
              effect="dark"
              :content="row.description"
              placement="top"
            >
              <span class="nowrap-ellipsis">{{ row.description }}</span>
            </el-tooltip>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否绑定本地功能项" slot="isBind" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.isBind">
              <span>已绑定</span>
              <div class="link primary" @click="seeAllBind(row)">查看</div>
            </div>
            <span v-else style="color: #ff687b;">未绑定</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" round @click="selectBind(row)">选择绑定</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </el-dialog>
    <el-dialog title="查看绑定功能项" :visible.sync="seeBindDiaShow" :close-on-click-modal="false" width="700px" @closed="bindInfoList = []">
      <div class="flex" style="align-items: flex-start;" v-loading="seeBindLoading">
        <div class="fx_box conent_s" v-if="bindInfoList && bindInfoList.length">
          <div><span>繁星功能项</span></div>
          <div>
            <span>繁星功能项编码</span>
            <span>{{bindInfoList[0].nameMd5}}</span>
          </div>
          <div>
            <span>繁星功能项名称</span>
            <span>{{bindInfoList[0].name}}</span>
          </div>
          <div>
            <span>繁星功能项描述</span>
            <span>{{bindInfoList[0].description}}</span>
          </div>
        </div>
        <div class="out_box conent_s" v-if="bindInfoList && bindInfoList.length">
          <div>
            <span>外部渠道</span>
            <span>{{handleChanne(bindInfoList[1].channelCode)}}</span>
          </div>
          <div>
            <span>外部等级ID</span>
            <span>{{bindInfoList[1].nameMd5}}</span>
          </div>
          <div>
            <span>外部等级名称</span>
            <span>{{bindInfoList[1].name}}</span>
          </div>
          <div>
            <span>等级描述</span>
            <span>{{bindInfoList[1].description}}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="seeBindDiaShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="`已绑定功能项（${allBindRow.name}）`" :maxHeight="500" :visible.sync="seeAllBindDiaShow" :close-on-click-modal="false" width="700px" @closed="allBindTableList = []">
      <GlobalTable ref="GlobalTable2" v-loading="allBindTableLoading" :columns="allBindTableColumns" :data="allBindTableList" :isPagination="false">
        <el-table-column label="选项描述" slot="optionTip" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              v-if="row.optionTip"
              class="item"
              effect="dark"
              :content="row.optionTip"
              placement="top"
            >
              <span class="nowrap-ellipsis">{{ row.optionTip }}</span>
            </el-tooltip>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="seeAllBindDiaShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="showViewerClose" :url-list="imgList" />
    <ModelConfigDia ref="modelConfigDia" @confirm="modelConfigNext" />
    <ModelSelectDia ref="modelSelectDia" :ids="machineIdList" :machineTypeId="machineTypeId"
      @confirm="modelSelectConfirm" />
  </div>
</template>

<script>
import _api from "@/utils/request";
import { http } from "@/utils/request/lowPhonemanagement";
import GardenSlwct from "@/components/common/gardenSlwct.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import ElImgUpload from "./dialog/upload-element.vue";
import ModelConfigDia from "./dialog/ModelConfigDia.vue";
import ModelSelectDia from "./dialog/ModelSelectDia.vue";
export default {
  name: "failure",
  components: {
    GardenSlwct,
    ElImageViewer,
    ElImgUpload,
    ModelConfigDia,
    ModelSelectDia
  },
  data() {
    return {
      classList: [],
      machineTypeId: "",
      tableLoading: false,
      tableData: [],
      tableColumns: [
        { label: "选项编码", prop: "failureCode" },
        { slotName: "optionName" },
        { slotName: "exampleImg" },
        { slotName: "optionTip" },
        { slotName: "model" },
        { slotName: "outFunction" },
        { label: "添加时间", prop: "createTime" },
        { slotName: "sort" },
        { slotName: "isEnable" },
        { slotName: "operation" },
      ],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      startType: "01",
      activeIndex: 0,
      tabData: [
        {
          text: '正常开机',
          value: '01',
          hideNum: true,
        },{
          text: '不能开机',
          value: '00',
          hideNum: true,
        }
      ],
      // 添加/编辑选项弹框
      addSelectTitle: "",
      addSelectDiaShow: false,
      confirmBtnLoading: false,
      formData: {
        isNormal: "",
        failureCode: "",
        optionName: "",
        optionTip: "",
        exampleImg: "",
      },
      formRule: {
        isNormal: [{ required: true, message: '请选择类型', trigger: 'change' }],
        failureCode: [
          { required: true, message: '请输入选项编码', trigger: 'blur' },
          { min: 6, message: '选项编码最少输入6位', trigger: 'change' }
        ],
        optionName: [{ required: true, message: '请输入选项名称', trigger: 'blur' }],
      },
      machineIdList: [],
      modelConfigFormData: {},
      // 示例图查看
      showViewer: false,
      imgList: [],
      // 启用禁用弹框
      sureTipDiaShow: false,
      sureTipBtnLoading: false,
      sureTipDiaText: "",
      sureTipDiaType: "",
      currentRow: {isEnable: ""},
      // 绑定功能项弹框
      channelList: [],
      bindOptionDiaShow: false,
      bindTableLoading: false,
      bindOptionDataList: [],
      bindTableColumns: [
        { slotName: "startType" },
        { label: "外部等级ID", prop: "nameMd5" },
        { label: "外部等级名称", prop: "name" },
        { slotName: "description" },
        { slotName: "isBind" },
        { slotName: "operation" },
      ],
      currentBindRow: {},
      bindOptionForm: {
        channelCode: 'pai',
        startType: '',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 查看绑定
      seeBindDiaShow: false,
      seeBindLoading: false,
      bindInfoList: [],
      // 查看外部功能绑定项
      seeAllBindDiaShow: false,
      allBindTableLoading: false,
      allBindTableList: [],
      allBindRow: {},
      allBindTableColumns: [
        { label: "选项编码", prop: "failureCode" },
        { label: "选项名称", prop: "optionName" },
        { slotName: "optionTip" },
      ],
    };
  },
  created() {
    this.getClassList();
    this.getMachineChannelList()
  },
  watch: {
    machineTypeId(val) {
      this.handleCurrentChange(1);
    }
  },
  methods: {
    // 获取分类集合
    getClassList() {
      http.selectLowList().then((res) => {
        this.classList = res.data ? res.data : [];
        this.machineTypeId = res.data && res.data.length?res.data[0].id:'';
      });
    },
    // 获取表格数据
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        machineTypeId: this.machineTypeId,
        startType: this.startType,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.tableLoading = true;
      http.getLowFailureList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.records;
          this.page.pageNum = res.data.current;
          this.page.total = res.data.total;
        }
        this.tableLoading = false;
      });
    },
    // 查看示例图大图
    seeSampleImage(row) {
      this.imgList = [];
      this.showViewer = true;
      this.imgList.push(row.exampleImg);
    },
    showViewerClose() {
      this.showViewer = false;
    },
    tabAction(val) {
      this.activeIndex = val;
      this.startType = this.tabData[val].value
      this.handleCurrentChange(1)
    },
    addSelection() {
      this.formData = {
        isNormal: "",
        failureCode: "",
        optionName: "",
        optionTip: "",
        exampleImg: "",
      }
      this.addSelectTitle = "添加选项"
      this.addSelectDiaShow = true
    },
    sampleHandleChange(v) {
      this.formData.exampleImg = v
    },
    sampleDelete() {
      this.formData.exampleImg = ''
    },
    modelConfigNext({ id, machineConfig }) {
      this.modelConfigFormData = { id, machineConfig }
      if (machineConfig == '00') {
        this.modelSelectConfirm()
      } else {
        http.getLowMachineConfig({ id }).then(res => {
          this.machineIdList = res.data.machineIdList
          this.$nextTick(() => {
            this.$refs['modelSelectDia'].open()
          })
        })
      }
    },
    modelSelectConfirm(machineIdList) {
      http.saveLowMachineConfig({
        ...this.modelConfigFormData,
        machineIdList
      }).then(res => {
        this.$message.success("修改成功");
        this.handleCurrentChange()
      })
    },
    confirmAdd() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let parame = {
            ...this.formData,
            machineTypeId: this.machineTypeId,
            startType: this.startType,
          };
          this.confirmBtnLoading = true;
          http.addLowFault(parame).then(res => {
            if(res.code === 1){
              this.$message.success(res.msg || "添加成功");
              this.handleCurrentChange(1)
              this.addSelectDiaShow = false
            }
          }).finally(() => {
            this.confirmBtnLoading = false
          })
        } else {
          return false;
        }
      });
      
    },
    closedAddSelectDia() {
      this.formData = {
        isNormal: "",
        failureCode: "",
        optionName: "",
        optionTip: "",
        exampleImg: "",
      }
      this.$refs.formRef.resetFields();
      this.$refs.formRef.clearValidate();
    },
    handleSortChange(row) {
      http
        .updateLowFaultSort({
          id: row.id,
          sort: row.sort,
        })
        .then((res) => {
          this.handleCurrentChange();
        });
    },
    handleSwitch(row) {
      this.currentRow = row
      this.sureTipDiaType = "isEnable"
      this.sureTipDiaText = row.isEnable ? "是否确认启用该项？" : "是否确认禁用该项？"
      this.sureTipDiaShow = true
    },
    sureTipDiaClosed() {
      if(this.sureTipDiaType === "isEnable"){
        this.handleCurrentChange()
      }
    },
    sureTipDiaSuccess() {
      if(this.sureTipDiaType === "isEnable"){
        let params = {
          id: this.currentRow.id,
          isEnable: this.currentRow.isEnable
        }
        this.sureTipBtnLoading = true
        http.updateLowFaultIsEnable(params).then(res => {
          if(res.code ===1){
            this.$message.success(res.msg || '操作成功')
            this.sureTipDiaShow = false
          }
        }).finally(() => {
          this.sureTipBtnLoading = false
        })
      }else if(this.sureTipDiaType === "del"){
        let params = {
          id: this.currentRow.id,
        }
        this.sureTipBtnLoading = true
        http.removeLowFaultById(params).then(res => {
          if(res.code ===1){
            this.$message.success(res.msg || '操作成功')
            this.sureTipDiaShow = false
            this.handleCurrentChange()
          }
        }).finally(() => {
          this.sureTipBtnLoading = false
        })
      }else if(this.sureTipDiaType === "bind"){
        let params = {
          lowFailureId: this.currentRow.id,
          nameMd5: this.currentBindRow.nameMd5,
          channelCode: this.bindOptionForm.channelCode
        }
        this.sureTipBtnLoading = true
        http.bindLowFailure(params).then(res => {
          if(res.code ===1){
            this.$message.success(res.msg || '操作成功')
            this.sureTipDiaShow = false
            this.bindOptionDiaShow = false
            this.handleCurrentChange()
          }
        }).finally(() => {
          this.sureTipBtnLoading = false
        })
      }else if(this.sureTipDiaType === "cancelBind"){
        let params = {
          id	: this.currentRow.id
        }
        this.sureTipBtnLoading = true
        http.cancelLowBind(params).then(res => {
          if(res.code ===1){
            this.$message.success(res.msg || '操作成功')
            this.sureTipDiaShow = false
            this.handleCurrentChange()
          }
        }).finally(() => {
          this.sureTipBtnLoading = false
        })
      }
    },
    // 绑定外部功能项
    bindItem(row) {
      this.currentRow = row
      this.bindOptionDiaShow = true
      this.bindCurrentChange()
    },
    delRow(row) {
      this.currentRow = row
      this.sureTipDiaType = "del"
      this.sureTipDiaText = "是否删除该选项？"
      this.sureTipDiaShow = true
    },
    editRow(row) {
      this.addSelectTitle = "编辑选项"
      this.formData.id = row.id
      this.formData.isNormal = row.isNormal
      this.formData.failureCode = row.failureCode
      this.formData.optionName = row.optionName
      this.formData.optionTip = row.optionTip
      this.formData.exampleImg = row.exampleImg
      this.addSelectDiaShow = true
    },
    // 获取外部机型渠道列表
    getMachineChannelList() {
      http.getMachineChannelList().then(res => {
        this.channelList = res.data || []
      })
    },
    handleChanne(code) {
      const item = this.channelList.find(item => item.key === code);
      return item ? item.value : '--';
    },
    // 分页
    bindCurrentChange(val) {
      if (val) {
        this.bindOptionForm.pageNum = val;
      }
      this.bindTableLoading = true
      http.getLowFailureOutList(this.bindOptionForm).then(res => {
        if (res.code === 1) {
          this.bindOptionDataList = res.data.records;
          this.bindOptionForm.pageNum = res.data.current;
          this.bindOptionForm.total = res.data.total;
        }
        this.bindTableLoading = false;
      })
    },
    selectBind(row) {
      this.currentBindRow = row
      this.sureTipDiaType = "bind"
      this.sureTipDiaText = "是否确认绑定该功能项？"
      this.sureTipDiaShow = true
    },
    cancelBind(row) {
      this.currentRow = row
      this.sureTipDiaType = "cancelBind"
      this.sureTipDiaText = "是否确认取消绑定该功能项？"
      this.sureTipDiaShow = true
    },
    seeBind(row) {
      this.seeBindDiaShow = true
      this.seeBindLoading = true
      http.getBind({id:row.id}).then(res => {
        if (res.code === 1) {
          this.bindInfoList = res.data
          this.seeBindLoading = false
        }
      })
    },
    seeAllBind(row) {
      this.allBindRow = row
      this.seeAllBindDiaShow = true
      this.allBindTableLoading = true
      http.getHasBind({nameMd5:row.nameMd5}).then(res => {
        if (res.code === 1) {
          this.allBindTableList = res.data
          this.allBindTableLoading = false
        }
      })
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.failure {
  /deep/ .global-chunk_header {
    border: 0;
  }
  /deep/.global-chunk_content{
    padding-top: 0 !important;
  }
  .case {
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    width: 100%;
    padding: 14px 0;

    .class_type {
      padding: 20px;

      .tip {
        font-size: 14px;
        color: #666666;
      }

      /deep/ .el-radio-group {
        .el-radio-button {
          margin-right: 20px;

          .el-radio-button__inner {
            border-radius: 4px;
            border: 1px solid #0981ff;
          }
        }
      }
    }

    .case-title {
      padding: 0 20px;
      display: flex;

      .case-title_icon {
        width: 20px;
        height: 20px;
        margin-right: 3px;
        margin-top: 10px;
      }

      .case-title_max {
        height: 17px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 41px;
      }
    }
  }

  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb{
    display: flex;
    justify-content: space-between;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  /deep/ .el-input-group__prepend {
    border: 1px solid #0981ff;
    background: #0981ff;
    color: #ffffff;
  }
  .conent_s{
    color: #333333;
    border-radius: 10px;
    flex: 1;
    &>div{
      margin-bottom: 10px;
      display: flex;
      &>span:first-child{
        flex-shrink: 0;
        margin-right: 10px;
        width: 85px;
        font-weight: bold;
      }
    }
  }
  .fx_box{
    background-color: #f1f5ff;
    margin-right: 20px;
    padding: 10px;
    &>div{
      &>span:first-child{
        flex-shrink: 0;
        margin-right: 10px;
        width: 98px !important;
      }
    }
    
  }
  .out_box{
    background-color: #fdf6ec;
    padding: 10px;
  }
}

.link {
  text-decoration: underline;
  cursor: pointer;

  &.primary {
    color: #0981ff;
  }

  &.danger {
    color: #ff687b;
  }
}

.nowrap-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
